import {
  ADD_TO_CART,
  CREATE_BOOKING,
  CREATE_IN_PROGRESS_BOOKING,
  SELECT_CHEF_FOR_BOOKING,
  SET_DINER_DETAILS,
  SET_CHEF_DETAILS,
  SET_CHEF_AVAILABILITY,
  UPDATE_IN_PROGRESS_BOOKING,
  SELECTED_BOOKING_DATE,
  SELECTED_BOOKING_SLOT,
  SET_BOOKING_COMPLETED_STEP,
  SET_EX_BOOKING,
  SET_IS_RECURRING_BOOKING,
  SET_CUSTOM_PRICE_RANGE,
  SET_CUSTOM_BOOKING_ADDRESS,
  SET_SELECTED_CHEF_AND_SLOT
} from "../stateConstants";
import { client } from "../../config/apollo";
import { GET_CHEF_DETAILS } from "../../graphql/queries/chef";
import { GET_CHEF_AVAILABILITY } from "../../graphql/queries/chef";
import {GET_DISH} from "../../graphql/queries/dishes";
import moment from "moment";

const initialState = {
  cart: [],
  exBooking: null,
  selectedChefId: null,
  inProgressBooking: null,
  booking: null,
  selectedChef: null,
  selectedDate: null,
  selectedSlot: null,
  chefAvailability: null,
  pendingBooking: null,
  showAddDish: true,
  bookingCompletedStep: 0,
  isRecurring: false,
  customPriceRange: null,
  customBookingAddress: null,
  selectedChefAndSlots: null
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    default:
      return state;

    case ADD_TO_CART:
      return {
        ...state,
        cart: action.result
      };

    case CREATE_BOOKING:
      return {
        ...state,
        booking: action.result
      };

    case CREATE_IN_PROGRESS_BOOKING:
      return {
        ...state,
        inProgressBooking: action.result
      };

    case UPDATE_IN_PROGRESS_BOOKING:
      return {
        ...state,
        pendingBooking: action.result,
        showAddDish: action.showAddDish,
      };

    case SELECT_CHEF_FOR_BOOKING:
      return {
        ...state,
        selectedChefId: action.result
      };

    case SET_CHEF_DETAILS:
      return {
        ...state,
        selectedChef: action.result
      };

    case SET_CHEF_AVAILABILITY:
      return {
        ...state,
        chefAvailability: action.result
      };

    case SELECTED_BOOKING_DATE:
      return {
        ...state,
        selectedDate: action.result,
      };

    case SELECTED_BOOKING_SLOT:
      return {
        ...state,
        selectedSlot: action.result,
      };

    case SET_EX_BOOKING:
      return {
        ...state,
        exBooking: action.result,
        showAddDish: action.showAddDish
      };

    case SET_BOOKING_COMPLETED_STEP:
      return {
        ...state,
        bookingCompletedStep: action.payload
      };

    case SET_IS_RECURRING_BOOKING:
      return {
        ...state,
        isRecurring: action.isRecurring
      };

    case SET_CUSTOM_PRICE_RANGE:
      return {
        ...state,
        customPriceRange: action.customPriceRange
      };

    case SET_CUSTOM_BOOKING_ADDRESS:
      return {
        ...state,
        customBookingAddress: action.address
      };

    case SET_SELECTED_CHEF_AND_SLOT:
      return {
        ...state,
        selectedChefAndSlots: action.payload
      };
  }
};

export default reducer;

export const addDish = dish => {
  return (dispatch, getState) => {
    const { cart, selectedChefId } = getState().bookings;
    if (!selectedChefId || selectedChefId != dish.chefId) {
      dispatch(selectedChef(dish.chefId));
    }
    dispatch(SelectedChefDetails(dish.chefId));
    dish.serves = dish.minDinerSize;
    cart.push(dish);
    dispatch({
      type: ADD_TO_CART,
      result: cart
    });
  };
};

export const initialCart = () => {
  return (dispatch, getState) => {
    dispatch({
      type: ADD_TO_CART,
      result: []
    });
  };
};

export const updateCart = cart => {
  return (dispatch, getState) => {
    dispatch({
      type: ADD_TO_CART,
      result: cart
    });
  };
};

export const removeDish = dish => {
  return (dispatch, getState) => {
    const { cart, selectedChefId } = getState().bookings;
    if (!selectedChefId) {
      dispatch(selectedChef(dish.chefId));
    }

    dispatch(SelectedChefDetails(dish.chefId));

    let index = cart.indexOf(dish);
    if (index > -1) {
      cart.splice(index, 1);
    }

    dispatch({
      type: ADD_TO_CART,
      result: cart
    });
  };
};

export const selectedChef = chefId => {
  return (dispatch, getState) => {
    dispatch({
      type: SELECT_CHEF_FOR_BOOKING,
      result: chefId
    });
  };
};

export const SelectedChefDetails = chefId => {
  return dispatch => {
    client
      .query({
        query: GET_CHEF_DETAILS,
        variables: {
          id: chefId
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        if (result.data.chef) {
          dispatch({
            type: SET_CHEF_DETAILS,
            result: result.data.chef
          });
        }
      });
  };
};

export const SelectedChefAvailability = (chefId, selectedDate) => {
  return dispatch => {
    client
      .query({
        query: GET_CHEF_AVAILABILITY,
        variables: {
          chefId: chefId,
          date: moment(selectedDate).format('YYYY-MM-DD')
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        dispatch({
          type: SET_CHEF_AVAILABILITY,
          result: result.data.getChefAvailability
        });
      })
      .catch(err => {
        console.log(JSON.parse(JSON.stringify(err)));
        dispatch({
          type: SET_CHEF_AVAILABILITY,
          result:
            "The chef is unavailable on this date. Please choose a different date."
        });
      });
  };
};

export const CreateInProgressBooking = bookingId => {
  return dispatch => {
    dispatch({
      type: CREATE_IN_PROGRESS_BOOKING,
      result: bookingId
    });
  };
};

export const pendingBooking = booking => {
    return (dispatch, getState) => {
          dispatch({
            type: ADD_TO_CART,
            result: []
          });
        const { cart, selectedChefId } = getState().bookings;

            dispatch(selectedChef(booking.chefId));
            dispatch(SelectedChefDetails(booking.chefId));

        booking.dishes.map(singleDish => {
            client
                .query({
                    query: GET_DISH,
                    variables: {
                        id: singleDish.dishId
                    },
                    fetchPolicy: "network-only"
                })
                .then(result => {
                    if(result.data.dish){
                      let dish=result.data.dish;
                        dish.serves = singleDish.serves;
                        cart.push(dish);
                    }
                })
                .catch(err => {
                    console.log(JSON.parse(JSON.stringify(err)));
                    });
            })

        dispatch({
            type: ADD_TO_CART,
            result: cart
        });
    };
};

export const setPendingBooking = (booking, showAddDish=true) => {
  return dispatch => {
    dispatch({
      type: UPDATE_IN_PROGRESS_BOOKING,
      result: booking,
      showAddDish,
    });
  }
};

export const setExBooking = (booking, showAddDish=true) => {
  return dispatch => {
    dispatch({
      type: SET_EX_BOOKING,
      result: booking,
      showAddDish,
    });
  }
};

export const setSelectedDate = date => {
  return dispatch => {
    dispatch({
      type: SELECTED_BOOKING_DATE,
      result: date
    });
  };
};

export const setSelectedSlot = slot => {
  return dispatch => {
    dispatch({
      type: SELECTED_BOOKING_SLOT,
      result: slot
    });
  };
};

export const setBookingCompletedStep = step => {
  return dispatch => dispatch({
    type: SET_BOOKING_COMPLETED_STEP,
    payload: step
  });
};

export const setIsRecurringBooking = isRecurring => {
  return dispatch => dispatch({
    type: SET_IS_RECURRING_BOOKING,
    isRecurring
  });
};

export const setCustomPriceange = priceRange => {
  return dispatch => dispatch({
    type: SET_CUSTOM_PRICE_RANGE,
    customPriceRange: priceRange
  });
};

export const setCustomBookingAddress = address => {
  return dispatch => dispatch({
    type: SET_CUSTOM_BOOKING_ADDRESS,
    address
  });
};

export const setSelectedChefAndSlots = payload => {
  return dispatch => dispatch({
    type: SET_SELECTED_CHEF_AND_SLOT,
    payload
  });
};
